import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RealMatch } from 'src/app/classes/real_match';
import { RealMatchService } from 'src/app/services/real-match.service';

@Component({
  selector: 'app-realmatch-table',
  templateUrl: './realmatch-table.component.html',
  styleUrls: ['./realmatch-table.component.scss']
})
export class RealmatchTableComponent implements OnInit {
  pathList: string[][];
  single: RealMatch;
  id: number;
  rels: any[];
  busy: Subscription;
 
  constructor(private ar: ActivatedRoute, private router: Router, public realMatchService: RealMatchService) {
  }
  
  pathList$($event) {
    this.pathList = $event;
  }

  ngOnInit(): void {
    this.rels = [];
    this.id = parseInt(this.ar.snapshot.paramMap.get('id'), 10);
    // this.pathList = [['RealMatches', 'real_match/list'], ['Match', "real_match/" + this.id ]];
    this.pathList = [];
    this.single = new RealMatch();
  }
}
